// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import {Highest_rated as Cmp} from '../shared/highest_rated';
import {Editor} from '../../../shared/editor/editor';
import cn from 'classnames';
import styles from './highest_rated.module.less';

export const Highest_rated = ()=>{
    return <Cmp info_cls={styles.country_info} cls={cn(styles.block)}
      colored mode="info" ladder arrows fetch_at_once t_prefix={'locations.'}
      trust_pilot={true}/>;
};

interface i_highest_rated_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const Highest_rated_editor = (
{value, on_change}: i_highest_rated_editor_props)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
